import React from "react";
import Service_Banner from "../service_common_components/service_banner/Service_Banner";
import Service_Content from "../service_common_components/service_content/Service_Content";
import Service_Specification from "../service_common_components/service_specification/Service_Specification";
import Key_Elements from "../service_common_components/key_elements/Key_Elements";
import Get_Quote from "../service_common_components/get_quote/Get_Quote";

const Interior = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Acoustic & Home Theatre Solutions ", link: "", isActive: true },
  ];

  const contentText = [
    "We specialize in creating soundproof and acoustically treated spaces for home theatres,  offices, studios, and study rooms. Our dedicated acoustic team uses advanced tools and  materials such as glass wool, acoustic panels, MDF board, mineral wool, bass traps,  diffusers, and perforated wooden panels to achieve superior sound insulation.",
    "We also design and install soundproof windows, doors, and partitions, ensuring minimal  noise interference. By combining modern audio-visual technology with expert acoustic  engineering, we deliver immersive home theatre experiences that rival cinema halls."
  ];

  const spcifications = [
    {
      img: "/assets/images/services/specifications/img1.png",
      titleText: "Space Optimization",
      subText: "Through the best smart space optimization interior design.",
    },
    {
      img: "/assets/images/services/specifications/img2.png",
      titleText: "Flexible Layouts",
      subText:
        "Flexible layouts for seamless with the new functionality & style.",
    },
    {
      img: "/assets/images/services/specifications/img3.png",
      titleText: "Smart Technology",
      subText: "Integrating smart technology to enhance and efficiency.",
    },
    {
      img: "/assets/images/services/specifications/img4.png",
      titleText: "Cost Efficiency",
      subText:
        "Achieving and functional interiors cost-efficient design solutions.",
    },
  ];

  const keyElements = [
    "We provide high quality design services.",
    "Project on time and Latest Design.",
    "Scientific Skills For getting a better result.",
    "Flexible with any structure of the building",
    "Commitment to customer service",
    "Experienced, time-served engineers",
    "We are confident about our projects.",
  ];

  return (
    <div>
      <Service_Banner
        imgSrc={"/assets/images/services/banners/residential.png"}
        title_text="SERVICES"
        breadcrumbs={breadcrumbs}
      />

      <Service_Content
        titleText="Acoustic & Home Theatre Solutions "
        contentText={contentText}
         imgSrc={"/assets/images/home/our_services/clients_images/acoustic.jpeg"}
      />

      <Service_Specification
        spcifications={spcifications}
        specifictaionDescn="It is a personalized session with a professional designer to discuss your vision, style, and project goals. This meeting provides you with expert advice on everything from furniture layout and color palettes to lighting and material selections. It's the perfect way to get clarity & direction, whether you're starting a full renovation or simply need help refreshing a single room."
      />

      <Key_Elements
        imgSrc1={"/assets/images/services/key_elements/commercial/img1.png"}
        imgSrc2={"/assets/images/services/key_elements/commercial/img2.png"}
        boxText="Key Elements"
        subText=" of Acoustic & Home Theatre Solutions"
        keyElements={keyElements}
      />

      <Get_Quote quotetext="We partner with our clients to develop unique design projects tailored to their specific needs. Our approach focuses on bringing their individual ideas and processes to life, rather than relying on one-size-fits-all solutions." />
    </div>
  );
};

export default Interior;
